module.exports = __webpack_public_path__ + "static/pipes-18c87024cc4e9419dbbf9020c8bedba9.svg";